/** Rótulos PT-BR para situation do frame livedata BSD. */
const LABELS: Record<string, string> = {
  possession:           'Posse de bola',
  attack:               'Ataque',
  dangerous:            'Jogada perigosa',
  safe:                 'Posse segura',
  corner:               'Escanteio',
  freekick:             'Falta',
  throwin:              'Lateral',
  goalkick:             'Tiro de meta',
  penalty:              'Pênalti',
  shotontarget:         'Chute no gol',
  shotofftarget:        'Chute fora',
  shotoffwoodwork:      'Na trave',
  goalkeeper_saved:     'Defesa do goleiro',
  goal:                 'Gol',
  offside:              'Impedimento',
  injury:               'Lesão',
  substitution:         'Substituição',
  periodscore:          'Fim de período',
  match_about_to_start: 'Preparando',
  match_started:        'Jogo iniciado',
  kickoff:              'Saída de bola',
  possible_event:       'Possível lance',
};

const ALTA_PRESSAO = new Set([
  'dangerous', 'attack', 'shotontarget', 'penalty', 'goal', 'possible_event',
]);

export function labelSituacaoPitch(situation: string | null | undefined): string {
  if (!situation) return 'Aguardando';
  return LABELS[situation] ?? situation.replace(/_/g, ' ');
}

export function isSituacaoAltaPressao(situation: string | null | undefined): boolean {
  return !!situation && ALTA_PRESSAO.has(situation);
}

const MAX_RASTRO = 14;

/** Últimos pontos do frame livedata — o payload traz o rastro e o widget só usava o último. */
export function rastroCoordenadas(
  coords: Array<{ x: number; y: number }> | null | undefined,
  max = MAX_RASTRO,
): Array<{ x: number; y: number }> {
  if (!coords?.length) return [];
  const fatia = coords.length > max ? coords.slice(-max) : coords;
  return fatia.filter((c) => Number.isFinite(c.x) && Number.isFinite(c.y));
}

const ARENA_OFF = 'scoreboard,ticker,ads,commentary,stats,controls,muted,names';

/** Embed 2D oficial do Arena (BSD). `key` é o embed key do dashboard, não a API token. */
export function urlArenaPitch2d(eventId: number, embedKey: string, aoVivo = true): string {
  const modo = aoVivo ? 'live' : 'replay';
  const key  = encodeURIComponent(embedKey);
  return `https://arena.bzzoiro.com/embed/${modo}/${eventId}/?key=${key}&dim=2&quality=high&off=${ARENA_OFF}`;
}

export function corDestaquePitch(situation: string | null | undefined): string {
  switch (situation) {
    case 'goal':             return '#fbbf24';
    case 'shotontarget':     return '#f8fafc';
    case 'shotoffwoodwork':  return '#fde68a';
    case 'penalty':          return '#fb923c';
    case 'dangerous':
    case 'attack':           return '#4ade80';
    case 'corner':
    case 'freekick':         return '#fb923c';
    default:                 return '#ffffff';
  }
}
